export default class DataSetColBooleanEditor
{
	name;
    label;
    visible = true;
    helpText = null;
    displayLength = 6;
    alignment = "Left";
    textTrue = null;
    textFalse = null;
    type = "Boolean";
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetColBooleanEditor.js